import * as actionTypes from '../../actions/actionTypes';

export const initialState = {
  byId: {}
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.shifts.INIT:
      return {
        byId: action.shifts.reduce((acc, shift) => ({ ...acc, [shift.shiftId]: shift }), {}),
      };
    case actionTypes.shifts.SET:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.shift.shiftId]: action.shift
        }
      };
    case actionTypes.shifts.SET_SHIFTS:
      return {
        byId: action.shifts.reduce((acc, shift) => ({ ...acc, [shift.shiftId]: shift }), {...state.byId}),
      };
    default:
      return state;
  }
};

export default reducer;